import React, {Component} from 'react';
import '../App.css';
import ArticleService from '../services/article-service';
import ArticlesColumn from './articles-column';
import _ from 'lodash';
import moment from 'moment';

export default class ArticleList extends Component {

  state = {
    loadedOk: null,
    evenArticles: [],
    oddArticles: [],
    width: window.innerWidth,
     height: window.innerHeight
  }

  componentDidMount() {
    this.loadArticles();
    window.addEventListener('resize', this.loadArticles);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.loadArticles);
  }

  windowSizes() {
    return {
      loadedOk: this.state.loadedOk,
      evenArticles: this.state.evenArticles,
      oddArticles: this.state.oddArticles,
      width: window.innerWidth,
      height: window.innerHeight
    };
  };

  loadArticles = () => {
    console.log('About to load articles');

    const artcileService = new ArticleService();
    artcileService.requestArticles()
      .then(data => {
        console.log('Got data', JSON.stringify(data));
        let unsortedArticles = data.data;

        let id = 0;
        if (unsortedArticles) {
          unsortedArticles = _.chain(unsortedArticles)
            .sortBy('createdTime')
            .reverse()
            .map(a => {
                // add an ID for use by React
                a.id = id++;
                return a;
            })
            .map(a => {
                // calculate human friendly last modified date
                // "2019-09-25T13:51:50+1000"
                const time = moment(a.lastModifiedTime, 'YYYY-MM-DDTHH:mm:ssZ');
                a.lastModifiedTimeHuman = time.fromNow();
                
                const time2 =  moment(a.createdTime, 'YYYY-MM-DDTHH:mm:ssZ');
                a.createdTimeHuman = time2.fromNow();
                
                return a;
            })
            .value();
        }

        let evenArticles = [];
        let oddArticles = [];

        if (this.state.width < 768) {
          console.log('Using one column mode.');
          // one column path
          for (let index = 0; index < unsortedArticles.length; ++index) {
            evenArticles.push(unsortedArticles[index]);
          }
          oddArticles = [];
        } else {
          console.log('Using two column mode.');

          // two columns path
          for (let index = 0; index < unsortedArticles.length; ++index) {

             if (index % 2 === 0) {
                evenArticles.push(unsortedArticles[index]);
              } else {
                oddArticles.push(unsortedArticles[index]);
              }
          }

          // rebalance articles, visually prefer odd column longer
          if (oddArticles.length < evenArticles.length) {
            oddArticles.push(evenArticles.pop());
          }
        }

        this.setState({
          loadedOk : true,
          articles : unsortedArticles,
          oddArticles: oddArticles,
          evenArticles: evenArticles,
          width: window.innerWidth,
          height: window.innerHeight
        });
      })
      .catch(error => {
        console.error('Got error', error);
        if (this.state.loadedOk !== true) {
          // only show error if we don't have any existing
          // weather to show, otherwise swallow error.
          this.setState({
            loadedOk : false,
            evenArticles: [],
            oddArticles: [],
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      });
  }
  
  render() {
    return (
      <React.Fragment>
        <div className="row">
            <div className="col-md-6">
                <ArticlesColumn loadedOk={this.state.loadedOk} articles={this.state.evenArticles} />
            </div>
            <div className="col-md-6">
                <ArticlesColumn loadedOk={this.state.loadedOk} articles={this.state.oddArticles} />
            </div>
        </div>
        <div>
          <span>Window size: {this.state.width} x {this.state.height}</span>
        </div>
      </React.Fragment>
    );
  }

}
